const projects = [
    {
      background_color: '#16314A',
      desktop_image: [
        require('./screenshots/t1.png'),
        require('./screenshots/t2.png'),
        require('./screenshots/t3.png'),
      ],
      mobile_image: '',
      title: 'Tigo Toolkit',
      date: '2018',
      github_url: '',
      project_url: 'http://comunicador.tigo.com.gt',
      tagline: 'Corporate messaging and data collection platform',
      background: "This is tigo's main corporate comunication tool.",
      role: 'I was the sole web developer for the platform and helped with the usability design and testing. This site was built using react shortly after it became widespread so it was a great oportunity to work in my react skills.',
      tech_stack: ['React.js', 'Redux', 'MongoDB', 'Node.js', 'express', 'Sass', 'Webpack']
    },
    {
      background_color: '#594663',
      desktop_image: [
        require('./screenshots/n1.png'),
        require('./screenshots/n2.png'),
        require('./screenshots/n3.png'),
      ],
      mobile_image: '',
      title: 'Notificame',
      date: '2016',
      github_url: '',
      project_url: 'http://notificame.claro.com.gt',
      tagline: 'Corporate messaging and client management platform',
      background: "This is claro's main corporate comunication tool.",
      role: 'This whole platform was to be designed and completed in just a few months with a single web developer. Python was the way to go since I had ample prior experience.',
      tech_stack: ['Python', 'Django', 'MySQL', 'Sass']
    },
    {
      background_color: '#9AB3CC',
      desktop_image: [
        require('./screenshots/p1.png'),
        require('./screenshots/p2.png'),
        require('./screenshots/p3.png'),
      ],
      mobile_image: '',
      title: 'Scholarship Candidate Selection Tool',
      date: '2012',
      github_url: '',
      project_url: 'http://becas.fundacionjbg.org',
      tagline: 'Tool for selecting candidates to participate in the scholarsip selection process',
      background: "This is Fundación Juan Bautista Gutierres selection tool",
      role: 'I was able to complete my studies as a graduate of the best university in my country thanks to this scholarship. I built this tool for them after I graduated and it is still used to date.',
      tech_stack: ['PHP', 'MySQL', 'CSS']
    }    
  ]

export default projects



// WEBPACK FOOTER //
// ./src/components/resources/projects.js